module.exports = "../../app/cells/pages/exams/cta_exams_list_cell.rb";